<script>
  export default {
    name: 'Checkmark',
    props: ['value', 'label'],
  }
</script>

<template>
  <label
    class="c--ui_checkmark checkbox tw-relative tw-flex tw-items-center tw-gap-4 tw-m-0 tw-cursor-pointer tw-select-none"
  >
    <input
      type="checkbox"
      class="tw-absolute tw-opacity-0 cursor-pointer tw-h-0 tw-w-0"
      @input="$emit('change', !value)"
      :checked="value"
    />
    <span
      class="checkmark tw-relative tw-flex tw-flex-shrink-0 tw-w-[28px] tw-h-[28px] tw-bg-[#4A4A4C] tw-rounded-[7px]"
    />
    <template v-if="label">
      <span class="checkmark-label tw-text-[#8A8A8A] tw-text-[14px]/[20px]">
        {{ label }}
      </span>
    </template>
  </label>
</template>

<style scoped lang="scss">
  .checkbox input:checked ~ .checkmark {
    background-color: #4a4a4c;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .checkbox input:checked ~ .checkmark:after {
    display: block;
  }

  .checkbox .checkmark:after {
    left: 10px;
    top: 5px;
    width: 8px;
    height: 14px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
</style>
